
import BackgroundAnimatedProg from "../components/BackgroundAnimatedProg";
import BackgroundAnimatedWaveTop from "../components/BackgroundAnimatedWaveTop";
import ProgramasCarousel from "../components/ProgramasCarousel";
import VideosProgramasCarousel from "../components/ProgramasCarouselVideo";


const Programas = () => {


    

  return (
    <>
    <BackgroundAnimatedProg/>
    <VideosProgramasCarousel/>
    <BackgroundAnimatedWaveTop/>
    </>
  );
};

export default Programas;
